<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.845"
    height="12.371"
    viewBox="0 0 25.845 12.371"
  >
    <g transform="translate(-387.212 -394.315)">
      <g>
        <path
          d="M412.68,405.29H393.215l.031-.534a40.977,40.977,0,0,1,1.236-7.671l.56.03.214-.144a4.38,4.38,0,0,0,1.045.847c.649.443,1.953-.3,2.638-.795l-.968-2.708.9.38a46.254,46.254,0,0,1,5.142,2.545,18.859,18.859,0,0,0,4.24,1.563,14.354,14.354,0,0,1,3.635,1.352c1.895,1.256.917,4.584.875,4.767Zm-18.558-1h17.9c.227-1.231.438-2.61-.548-3.264a14.132,14.132,0,0,0-3.418-1.251,19.293,19.293,0,0,1-4.418-1.639,46.182,46.182,0,0,0-4.14-2.1l.487,1.361-.281.232c-.25.2-2.474,1.989-3.832,1.059-.318-.217-.563-.4-.752-.554A38.032,38.032,0,0,0,394.122,404.29Z"
          fill="#777"
        />
        <rect
          width="2.759"
          height="0.999"
          transform="translate(401.339 399.264) rotate(-60.477)"
          fill="#777"
        />
        <rect
          width="2.484"
          height="1"
          transform="translate(403.087 399.988) rotate(-59.203)"
          fill="#777"
        />
      </g>
      <rect
        width="1.586"
        height="1"
        transform="translate(411.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(409.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(407.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(405.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(403.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(401.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(399.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(397.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(395.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="1.586"
        height="1"
        transform="translate(393.327 406.461) rotate(-77.022)"
        fill="#777"
      />
      <rect
        width="4"
        height="1"
        transform="translate(388.212 402.863)"
        fill="#777"
      />
      <rect
        width="5"
        height="1"
        transform="translate(387.212 400.863)"
        fill="#777"
      />
      <rect
        width="4"
        height="1"
        transform="translate(389.212 398.863)"
        fill="#777"
      />
    </g>
  </svg>
</template>
